
import './screen.scss';
import { env } from './environment';

// Configure InstUI Theme
import { theme } from '@instructure/canvas-theme'
theme.use({ overrides: { ...env.brand_variables } });

// Configure Sentry
import * as Sentry from '@sentry/browser';
if (env.environment != 'development') {
    Sentry.init({
        dsn: env.sentry_dsn,
        environment: env.environment,
    });
}

// Configure MobX
import * as mobx from 'mobx';
mobx.configure({
    enforceActions: 'observed',
})

// Configure Moment
import moment from 'moment-timezone';
moment.tz.setDefault(env.timezone || moment.tz.guess());
